module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/190GdMg/tc-custom/9781423608714.jpg?1721429532216",
      "alt": "This image is the cover for the book 101 Things To Do With Chicken, 101 Things To Do With"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("101 Things To Do With Chicken, 101 Things To Do With\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("From the authors of "), _c('i', [_vm._v("101 Things to Do With Cake Mix")]), _vm._v(" and "), _c('i', [_vm._v("101 Things to Do With Canned Soup")]), _vm._v(", 101 amazing yet easy ways to serve up chicken.")])]), _c('p', [_c('b')]), _c('p', [_c('i', [_vm._v("101 Things to Do with Chicken")]), _vm._v(" is a must have for the busy kitchen. From appetizers, soups and salads to sandwiches, wraps and international entrees, these effortless recipes can be used for every occasion. Try delicious dishes such as: Blue Cheese Chicken Dip, Curried Chicken Salad, Grandma's Chicken Noodle Soup, Zesty Chicken Burgers, Cranberry Chicken Spinach Wraps, Garlic Lover's Roast Chicken, Balsamic Chicken Stacks, Mediterranean Chicken, Asian Lettuce Wraps, and Chicken Alfredo Pizza.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Donna Kelly, Stephanie Ashcraft\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephanie Ashcraft, author of the original 101 Things To Do With A Cake Mix, has taught cooking classes based on the tips and meals in her cookbooks for almost twenty years. She lives in Tucson, Arizona. Donna Kelly is the author of several cookbooks, including French Toast, 101 Things To Do With a Tortilla, 101 Things To Do With Chicken, 101 Things To Do With Tofu, 101 Things To Do with Canned Soup, and 101 Things To Do With a Toaster Oven. She lives in Provo, Utah.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0